// third-party
import { FormattedMessage } from 'react-intl';

// assets
import PhoneCallbackOutlinedIcon from '@mui/icons-material/PhoneCallbackOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

// ==============================|| MENU ITEMS - CRM ||============================== //

const crm = {
  id: 'crm',
  title: <FormattedMessage id="CRM" />,
  icon: PhoneCallbackOutlinedIcon,
  type: 'group',
  children: [
    {
      id: 'inbound_crm',
      key: 'inbound_crm',
      title: <FormattedMessage id="Call CRM" />,
      type: 'item',
      url: '/admin/inbound-crm',
      icon: PhoneCallbackOutlinedIcon
    },
    {
      id: 'whatsapp_conversations',
      key: 'whatsapp_conversations',
      title: <FormattedMessage id="WhatsApp Conversations" />,
      type: 'item',
      url: '/admin/whatsapp-conversations',
      icon: WhatsAppIcon
    }
  ]
};

export default crm;
